import styled from 'styled-components';

export const PriceWrapper = styled.div`
	padding-top: 30px;
`;

export const PriceTitle = styled.h3`
	color: #000;
	font-size: 20px;
	font-weight: 700;
	line-height: normal;
	text-transform: uppercase;
	margin-bottom: 20px;
`;

export const TrialPrice = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 0;
	border-top: solid 0.5px #dbd9f7;
	border-bottom: solid 0.5px #dbd9f7;

	p:first-child {
		color: #000;
		font-size: 16px;
		line-height: 20px;
	}

	p:last-child {
		font-size: 16px;
		line-height: 20px;
		font-weight: 700;

		span {
			color: #979797;
			font-weight: 400;
			text-decoration: line-through;
			text-decoration-line: strikethrough;
		}
	}
`;

export const TrialInfo = styled.p`
	color: #979797;
	font-size: 14px;
	line-height: 20px;
	margin-top: 20px;
	margin-bottom: 30px;
`;

export const PriceAfterTitle = styled.h3`
	color: #000;
	font-size: 20px;
	font-weight: 700;
	line-height: normal;
	text-transform: uppercase;
	margin-bottom: 20px;
`;

export const AfterInfo = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 10px 0;
	border-top: solid 0.5px #dbd9f7;
	border-bottom: solid 0.5px #dbd9f7;

	p:first-child {
		color: #000;
		font-size: 16px;
		line-height: 20px;
	}

	p:last-child {
		font-size: 16px;
		line-height: 20px;
		font-weight: 700;
		text-align: right;

		span {
			font-size: 12px;
			font-weight: 500;
		}
	}
`;

export const Disclaimer = styled.p`
	color: #979797;
	font-size: 14px;
	line-height: 20px;
	margin-top: 20px;
	margin-bottom: 30px;
`;
